import React, { useState } from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "drawingNo",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "sequenceNo",
        headerName: "Sequence No",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "processDetail",
        headerName: "Process detail",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "bom",
        headerName: "BOM",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "qty",
        headerName: "Qty",
        minWidth: window.innerWidth * 0.07,
        flex: 0.7,
        filter: true,
    },
    {
        field: "currentStock",
        headerName: "Current stock",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "weight",
        headerName: "Weight",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
];

const dtSerialColdefs = [
    { headerName: "ID", field: "idMaterialProductionIssueSerial", hide: true },
    { headerName: "Material Issue Job Work ID", field: "idMaterialIssueJobWork", hide: true },
    { headerName: "Item ID", field: "idItem", width: 120, hide: true },
    { headerName: "Item Name", field: "itemName", minWidth: 180 },
    { headerName: "Serial No", field: "serialNo", editable: true, width: 120 },
    { headerName: "Remarks", field: "remarks", editable: true, flex: 1 },
];

const IssueProcessTransactionTable = (props) => {

    const [tab, setTab] = useState(false)

    const EmployeeSelectEditor = (param) => {
        return (
            <MultiSelectDropdown
                drpIdentity="Select employee"
                options={props.processObject?.employeeList}
                value={
                    param.data?.idEmployee
                        ? props.processObject?.employeeList.find(
                            (x) => x.value === param.data.idEmployee
                        )
                        : null
                }
                onChange={(event) => {
                    props.handleIsEmployeeChange(param, event);
                    param.stopEditing();
                }}
            />
        );
    };

    const EmployeeCountCell = (param) => {
        const isDisabled = param.data.idMaterialIssueJobWorkDetails <= 0;
        return (
            <div
                className={`employee-count-cell flex items-center gap-5 h-full px-2 ${isDisabled ? "pointer-events-none opacity-50" : ""}`}
                disabled={isDisabled}
            >
                <span>
                    {param.data?.employee}
                </span>
                <button
                    disabled={isDisabled}
                    onClick={() => props.handleIsEmployeeChange(param)}
                    className='edit-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                >
                    <FontAwesomeIcon icon={faUsers} />
                </button>
            </div>
        );
    };

    const CheckboxRenderer = (params) => {
        const handleChange = (e) => {
            e.stopPropagation();
            if (params.data.isDisabled) return;
            const newValue = e.target.checked;
            params.node.setDataValue('isSelected', newValue);
        };

        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <input
                    type="checkbox"
                    checked={!!params.value}
                    onChange={handleChange}
                    disabled={params.data.isDisabled}
                    style={{ cursor: params.data.isDisabled ? 'not-allowed' : 'pointer', width: '16px', height: '16px' }}
                />
            </div>
        );
    };

    const itemRowDataColsdefs = [
        // { headerName: "Select", field: "isSelected", width: 90, editable: (params) => !params.data.isDisabled },
        {
            headerName: "Select",
            field: "isSelected",
            width: 90,
            editable: false, // disable ag-grid's own editing, checkbox handles it
            cellRenderer: CheckboxRenderer,
        },
        { headerName: "Sequence No", field: "sequenceNo", width: 120 },
        { headerName: "Process", field: "processDetails", minWidth: 150 },
        {
            headerName: "Is Start",
            field: "isStart",
            cellRenderer: 'agCheckboxCellRenderer',
            cellEditor: 'agCheckboxCellEditor',
            editable: (params) => !params.data.isDisabled && params.data.isSelected === true && params.data.idMaterialIssueJobWorkDetails > 0, width: 100
        },
        {
            headerName: "Start Date",
            field: "startDate",
            width: 150,
            editable: (params) => !params.data.isDisabled,
            valueFormatter: (params) => {
                return params.value ? moment(params.value).format('DD-MM-YYYY') : '';
            }
        },
        {
            headerName: "Employee",
            field: "employee",
            // editable: false,
            width: 250,
            // cellEditor: EmployeeSelectEditor,
            cellRenderer: EmployeeCountCell,
            cellEditorParams: {
                processObject: props.processObject,
            },

        },
        { headerName: "Job Work", field: "jobWork", width: 100, editable: (params) => !params.data.isDisabled },
        { headerName: "Quantity", field: "quantity", editable: (params) => !params.data.isDisabled, width: 120 },
        { headerName: "Pending Qty", field: "pendingQty", width: 120, editable: (params) => !params.data.isDisabled },
        { headerName: "Is Pending", field: "isPending", width: 100, editable: (params) => !params.data.isDisabled },
        { headerName: "Is Complete", field: "isComplete", editable: (params) => !params.data.isDisabled && params.data.isSelected === true && params.data.isStart === true, width: 120 },
        {
            headerName: "Completion Date",
            field: "completionDate",
            width: 150, editable:
                (params) => !params.data.isDisabled && params.data.isStart === true && params.data.idMaterialIssueJobWorkDetails > 0,
            valueFormatter: (params) => {
                return params.value ? moment(params.value).format('DD-MM-YYYY') : '';
            }
        },
        { headerName: "Reject Qty", field: "rejectQty", width: 120 },
        { headerName: "Re Work Qty", field: "reWorkQty", width: 120 },
        { headerName: "Pass Qty", field: "passQty", width: 120 },
        { headerName: "Is QC", field: "isQc", width: 90, editable: (params) => !params.data.isDisabled },
        { headerName: "QC Date", field: "qcDate", width: 150, editable: (params) => !params.data.isDisabled },
        { headerName: "QC Employee", field: "qcEmployee", width: 150, editable: (params) => !params.data.isDisabled },
        { headerName: "Remarks", field: "remarks", editable: (params) => !params.data.isDisabled, flex: 1 },
    ];

    const handleCellValueChanged = (params) => {
        if (params.colDef.field === "isSelected") {
            params.api.refreshCells({
                rowNodes: [params.node],
                columns: ["isStart"],
                force: true,
            });
        }
        if (params.colDef.field === 'isStart' && params.data.idMaterialIssueJobWorkDetails > 0) {
            props.handleIsStartChange(params);
        }
        if (params.colDef.field === 'employee') {
            props.handleIsEmployeeChange(params);
        }
        if (params.colDef.field === 'pendingQty') {
            props.handleIsPendingQtyChange(params);
        }
        if (params.colDef.field === 'isComplete' && params.data.isStart === true && params.data.idMaterialIssueJobWorkDetails > 0) {
            props.handleIsCompleteChange(params)
        }
    };

    const handleCellClickItemList = (params) => {
        if (params.column.colId === 'isSelected') return;
        if (params.colDef.field === 'employee') {
            props.handleIsEmployeeChange(params);
        }
        if (params.colDef.field === 'isStart' && params.data.idMaterialIssueJobWorkDetails > 0) {
            const isEditable = !params.data.isDisabled && params.data.isSelected === true;

            if (isEditable) {
                const newValue = !params.data.isStart;
                params.node.setDataValue('isStart', newValue);

                props.handleIsStartChange({
                    ...params,
                    newValue: newValue,
                    oldValue: params.data.isStart
                });
            }
        }
        if (params.colDef.field === 'isComplete' && params.data.isStart === true && params.data.idMaterialIssueJobWorkDetails > 0) {
            const isEditable = !params.data.isDisabled && params.data.isSelected === true;

            if (isEditable) {
                const newValue = !params.data.isComplete;
                params.node.setDataValue('isComplete', newValue);

                props.handleIsCompleteChange({
                    ...params,
                    newValue: newValue,
                    oldValue: params.data.isComplete
                });
            }
        }
    }

    return (
        <ModalBasic
            id="stock-to-plant"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className="tabbing-btns flex gap-5 items-center mb-3 p-[30px] pb-0">
                <span className={` text-[16px] py-[5px] px-[15px] rounded-[8px] font-semibold cursor-pointer ${tab ? "text-blue bg-lightBlue hover:bg-[#3f8cff33]" : "text-white bg-blue"}`} onClick={() => setTab(false)}>Material job work</span>
                <span className={` text-[16px] py-[5px] px-[15px] rounded-[8px] font-semibold cursor-pointer ${tab ? "text-white bg-blue" : "text-blue bg-lightBlue hover:bg-[#3f8cff33]"}`} onClick={() => setTab(true)}>Pending job work</span>
            </div>
            {tab === false ? (
                <div className='input-fields p-[30px] pt-0'>
                    <span className="text-blue text-[16px] font-semibold">Material issue details</span>
                    <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                        <div className='input-grp'>
                            <label>Job work no</label>
                            <TextInput type='text'
                                id='jobworkNo' name='jobworkNo'
                                value={props.processObject.jobworkNo}
                                handleChange={(event) => props.handleChange(event, 'jobworkNo')}
                                className={props.validState?.error?.jobworkNo !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Job work date</label>
                            <TextInput type='date'
                                id='jobWorkDate' name='jobWorkDate'
                                value={props.processObject.jobWorkDate}
                                handleChange={(event) => props.handleChange(event, 'jobWorkDate')}
                                className={props.validState?.error?.jobWorkDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Auth employee</label>
                            {/* <MultiSelectDropdown
                                drpIdentity="Select employee"
                                options={props.processObject.authEmpList}
                                value={props.processObject.employee > 0 ? props.processObject.authEmpList.find(x => x.value === props.processObject.employee) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "employee")
                                }
                                className={props.validState?.error?.employee !== undefined ? "error" : ""}
                            /> */}
                            <TextInput type='text'
                                id='usp_Users' name='usp_Users'
                                value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Jobwork from</label>
                            <MultiSelectDropdown
                                drpIdentity="Select jobwork"
                                options={props.processObject.jwFromList}
                                value={props.processObject.idJwFrom > 0 ? props.processObject.jwFromList.find(x => x.value === props.processObject.idJwFrom) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idJwFrom")
                                }
                                className={props.validState?.error?.idJwFrom !== undefined ? "error" : ""}
                                isDisabled={true}
                            />

                        </div>
                        <div className='input-grp'>
                            <label>Drawing no</label>
                            <TextInput type='text'
                                id='drawingNo' name='drawingNo'
                                value={props.processObject.drawingNo}
                                handleChange={(event) => props.handleChange(event, 'drawingNo')}
                                className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Select item</label>
                            {/* <MultiSelectDropdown
                                drpIdentity="Select product"
                                options={props.processObject.itemList}
                                value={props.processObject.idItem > 0 ? props.processObject.itemList.find(x => x.value === props.processObject.idItem) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idItem")
                                }
                                className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                            /> */}
                            <TextInput
                                id="Select Item"
                                name="Select Item"
                                value={props.processObject.itemName}
                                handleOnClick={(event) => props.handleOnClick(event, "itemList")}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Select type</label>
                            <MultiSelectDropdown
                                drpIdentity="Select type"
                                options={props.processObject.typeList}
                                value={props.processObject.idType > 0 ? props.processObject.typeList.find(x => x.value === props.processObject.idType) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idType")
                                }
                                className={props.validState?.error?.idType !== undefined ? "error" : ""}
                            />

                        </div>
                        <div className='input-grp'>
                            <label>Quantity</label>
                            <TextInput type='number'
                                id='quantity' name='quantity'
                                value={props.processObject.quantity}
                                handleChange={(event) => props.handleChange(event, 'quantity')}
                                className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>

                        <div className='input-grp'>
                            <label>Used qty</label>
                            <TextInput type='number'
                                id='usedQty' name='usedQty'
                                value={props.processObject.usedQty}
                                handleChange={(event) => props.handleChange(event, 'usedQty')}
                                className={props.validState?.error?.usedQty !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Pass qty</label>
                            <TextInput type='number'
                                id='passQty' name='passQty'
                                value={props.processObject.passQty}
                                handleChange={(event) => props.handleChange(event, 'passQty')}
                                className={props.validState?.error?.passQty !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Pend. qty</label>
                            <TextInput type='number'
                                id='pendQty' name='pendQty'
                                value={props.processObject.pendQty}
                                handleChange={(event) => props.handleChange(event, 'pendQty')}
                                className={props.validState?.error?.pendQty !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Rej. qty</label>
                            <TextInput type='number'
                                id='rejQty' name='rejQty'
                                value={props.processObject.rejQty}
                                handleChange={(event) => props.handleChange(event, 'rejQty')}
                                className={props.validState?.error?.rejQty !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Rework qty</label>
                            <TextInput type='number'
                                id='reworkQty' name='reworkQty'
                                value={props.processObject.reworkQty}
                                handleChange={(event) => props.handleChange(event, 'reworkQty')}
                                className={props.validState?.error?.reworkQty !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>W.O.</label>
                            <TextInput type='number'
                                id='wo1' name='wo1'
                                value={props.processObject.wo1}
                                handleChange={(event) => props.handleChange(event, 'wo1')}
                                className={props.validState?.error?.wo1 !== undefined ? "error" : ""}
                                disabled={true}
                            />
                            <TextInput type='number'
                                id='wo2' name='wo2'
                                value={props.processObject.wo2}
                                handleChange={(event) => props.handleChange(event, 'wo2')}
                                className={props.validState?.error?.wo2 !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Plant</label>
                            {/* <TextInput type='number'
                                id='plant1' name='plant1'
                                value={props.processObject.plant1}
                                handleChange={(event) => props.handleChange(event, 'plant1')}
                                className={props.validState?.error?.plant1 !== undefined ? "error" : ""}
                            />
                            <TextInput type='number'
                                id='plant2' name='plant2'
                                value={props.processObject.plant2}
                                handleChange={(event) => props.handleChange(event, 'plant2')}
                                className={props.validState?.error?.plant2 !== undefined ? "error" : ""}
                            /> */}
                            <MultiSelectDropdown
                                drpIdentity="Select Plant"
                                options={props.processObject.plantList}
                                value={props.processObject.plantId1 > 0 ? props.processObject.plantList.find(x => x.value === props.processObject.plantId1) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "plantId1")
                                }
                                className={props.validState?.error?.idNumber !== undefined ? "error" : ""}
                                isDisabled={true}
                            />
                            <MultiSelectDropdown
                                drpIdentity="Select plantId2"
                                options={props.processObject.plantList}
                                value={props.processObject.plantId2 > 0 ? props.processObject.plantList.find(x => x.value === props.processObject.plantId2) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "plantId2")
                                }
                                className={props.validState?.error?.idNumber !== undefined ? "error" : ""}
                                isDisabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>W.O. date</label>
                            <TextInput type='date'
                                id='woDate1' name='woDate1'
                                value={props.processObject.woDate1}
                                handleChange={(event) => props.handleChange(event, 'woDate1')}
                                className={props.validState?.error?.woDate1 !== undefined ? "error" : ""}
                                disabled={true}
                            />
                            <TextInput type='text'
                                id='actualIDItem' name='actualIDItem'
                                value={props.processObject.actualIDItem}
                                handleChange={(event) => props.handleChange(event, 'actualIDItem')}
                                className={props.validState?.error?.actualIDItem !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>

                        <div className='input-grp'>
                            <label>Select no</label>
                            <MultiSelectDropdown
                                drpIdentity="Select number"
                                options={props.processObject.selectNoList}
                                value={props.processObject.idSelectNo1 > 0 ? props.processObject.selectNoList.find(x => x.value === props.processObject.idSelectNo1) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idSelectNo1")
                                }
                                className={props.validState?.error?.idSelectNo1 !== undefined ? "error" : ""}
                            />
                            {/* <MultiSelectDropdown
                                drpIdentity="Select number"
                                options={props.processObject.selectNoList}
                                value={props.processObject.idNumber2 > 0 ? props.processObject.selectNoList.find(x => x.value === props.processObject.idNumber2) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idNumber2")
                                }
                                className={props.validState?.error?.idNumber2 !== undefined ? "error" : ""}
                            /> */}
                            <TextInput
                                id="Select production No"
                                name="Select production No"
                                value={props.processObject.productionNo}
                                handleOnClick={(event) => props.handleOnClick(event, "productionNo")}
                                disabled={props.processObject.idSelectNo1 === 1 ? true : false}
                            />
                        </div>

                        <div className='input-outer !h-full justify-end flex flex-col gap-[10px]'>
                            <div className='input-grp !inline-flex flex-row-reverse justify-end !gap-[10px]'>
                                <label>Process is complete?</label>
                                <input type='CheckBox'
                                    className='shadow-none w-[15px] h-[15px]'
                                    id='isCompleteProcess' name='isCompleteProcess'
                                    //value={props.processObject.isCompleteProcess}
                                    checked={props.processObject.isCompleteProcess === true ? true : false}
                                    onClick={(event) => props.handleChange(event, 'isCompleteProcess')}
                                    disabled={!props.itemRowData?.every(item => item.isComplete)}
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Date</label>
                                <TextInput type='date'
                                    id='date' name='date'
                                    value={props.processObject.date}
                                    handleChange={(event) => props.handleChange(event, 'date')}
                                    className={props.validState?.error?.date !== undefined ? "error" : ""}
                                    disabled={!props.itemRowData?.every(item => item.isComplete)}
                                />
                            </div>
                        </div>

                        <div className='input-grp col-span-2'>
                            <label>Remarks</label>
                            <TextInput type='text'
                                id='remarks' name='remarks'
                                value={props.processObject.remarks}
                                handleChange={(event) => props.handleChange(event, 'remarks')}
                                className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                            />
                        </div>

                        <div className='btn-grp flex gap-2.5 mt-5'>
                            <button className="save-btn btns" onClick={() => props.btnAddPreocess_Click()}>Add item process</button>
                            <button className="save-btn btns" onClick={() => props.downloadIssueProcessEmployeeReport()}>Employee Report</button>
                        </div>
                    </div>
                    <div className="process-table h-[40vh] mt-2.5">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.itemRowData}
                                columnDefs={itemRowDataColsdefs}
                                onCellClicked={handleCellClickItemList}
                                //onGridReady={props.onGridReady}
                                //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                onCellValueChanged={handleCellValueChanged}
                                singleClickEdit={true}
                            />
                        </div>
                    </div>
                    <div className='btn-total flex items-end justify-between mt-[35px]'>
                        <div className='btn-grp flex gap-2.5'>
                            {props.isSubmitButtonLoading ?
                                <button className="update-btn btns !bg-gray-400 cursor-not-allowed">Loading...</button>
                                :
                                <>
                                    {props.processObject.idMaterialIssueJobWork > 0 ?
                                        <button
                                            disabled={props.isSubmitButtonLoading}
                                            className="update-btn btns" onClick={() => props.submit()}>Update</button>
                                        :
                                        <button
                                            disabled={props.isSubmitButtonLoading}
                                            className="update-btn btns"
                                            onClick={() => props.submit()}>
                                            Save
                                        </button>
                                    }
                                </>
                            }
                            <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                            {props.permissions.isDelete && props.processObject.idMaterialIssueJobWork > 0 ?
                                <button className="delete-btn btns" onClick={() => props.usp_Transaction_MaterialIssue_JobWorkRecordDelete()}>Delete </button>
                                : null}
                        </div>
                    </div>
                </div>
            ) : (
                <div className='tables p-[30px] pt-0'>
                    <div className="first-table h-[40vh] mt-2.5">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.processObject.pendingJobWorkDataList}
                                columnDefs={props.processObject.colPendingJobWorkData}
                                onCellClicked={props.handleCellClickItemList}
                            //onGridReady={props.onGridReady}
                            //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            />
                        </div>
                    </div>
                    <div className="second-table h-[40vh] mt-2.5">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.processObject.pendingJobWorkDataList2}
                                columnDefs={itemColdefs}
                                onCellClicked={props.handleCellClickItemList}
                            //onGridReady={props.onGridReady}
                            //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            />
                        </div>
                    </div>
                </div>
            )}
        </ModalBasic>
    )
}

export default IssueProcessTransactionTable